import useMobile from 'common/hooks/useMobile';
import useSpringViewportScroll from 'common/hooks/useSpringViewportScroll';
import React, { useState,  } from 'react';

const SatisfactionContext = React.createContext();

export const SatisfactionContextProvider = ({ children }) => {

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const isMobile = useMobile();
    const [displayModal, setModal] = useState(true);
    const scrollY = useSpringViewportScroll();

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen)
    }

    const value = {
        isMobile,
        isMobileMenuOpen: mobileMenuOpen,
        toggleMobileMenu,
        scrollY,
        displayModal,
        closeModal: () => { setModal(false);}
    }

    return <SatisfactionContext.Provider value={value} >{children}</SatisfactionContext.Provider>

}

export const SatisfactionContextConsumer = SatisfactionContext.Consumer;

export default SatisfactionContext;